import React, { useEffect } from 'react';
import LazyLoad, { forceCheck } from 'react-lazyload';
import Card from 'react-bootstrap/Card';
import CategoryViewGame from './CategoryViewGame';
import '../../../../../../assets/stylesheets/slots.scss';

export default function CategoryViewGameList({ games, user, requestSlotUrl }) {
  const userId = user ? user.id : null;

  useEffect(() => forceCheck(), [games]);

  return (
    <ul className="games">
      {games.map((game, index) => (
        <LazyLoad key={index} height={105} offset={110} once overflow placeholder={(
          <li className="games__element">
            <Card className="games__element__card" />
          </li>)}>
          <li className="games__element">
            <CategoryViewGame game={game} userId={userId} requestSlotUrl={requestSlotUrl} />
          </li>
        </LazyLoad>
      ))}
    </ul>
  );
}
